/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from '@angular/core';
import {ServiceProviderQualificationViewModel} from '@well/domain';
import { HttpClient } from '@angular/common/http';
import {EnvironmentService} from "@irian-ro/util-environment";
import {AbstractResourceService} from '@irian-ro/abstract-resource';

@Injectable({
  providedIn: 'root'
})
export class DeliveryServiceProviderQualificationResourceService extends AbstractResourceService<ServiceProviderQualificationViewModel, any, any, any> {

  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('deliveryServiceProviderUrl') + '/qualification',
      ServiceProviderQualificationViewModel
    );
  }
}
